import { render, staticRenderFns } from "./OrganizeLocation.vue?vue&type=template&id=21f3fd1e&scoped=true&"
import script from "./OrganizeLocation.vue?vue&type=script&lang=js&"
export * from "./OrganizeLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3fd1e",
  null
  
)

export default component.exports